import { FC } from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import { standardizeUrl } from '@frx/frx-services';
import { formatDollarAmount, TeamMemberProps } from '../../utils';

export const TeamMember: FC<Partial<TeamMemberProps>> = (
  props
): JSX.Element => {
  const { memberDisplayName, amountRaised, photoUrl } = props;

  const displayAmountRaised = formatDollarAmount(amountRaised || 0);
  const imageUrl = standardizeUrl(photoUrl || '', true);

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center">
        <Image
          alt="Team Member"
          src={imageUrl}
          w="48px"
          h="48px"
          borderRadius="50%"
        />
        <Text pl="1rem">{memberDisplayName}</Text>
      </Flex>
      <Text>{displayAmountRaised}</Text>
    </Flex>
  );
};
